import Head from 'next/head';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import previewExpertise from '../../public/preview/preview-expertise.png';
import { Footer, Header } from '../../components';
import menu from '../../utils/menu';
import RealEstatePage from './real-estate';

export default function RealEstate() {
  return (
    <>
      <Head>
        <title>Amalthea: Revolutionizing Property Management</title>
        <meta
          property="og:title"
          content="Amalthea: Revolutionizing Property Management"
        />
        <meta property="og:image" content={`${previewExpertise.src}`} />
        <meta name="twitter:image" content={`${previewExpertise.src}`} />
        <meta
          property="og:image:alt"
          content="Amalthea: Revolutionizing Property Management"
        />
        <meta property="og:type" content="product" />
        <meta
          property="og:description"
          content="Explore Amalthea, our revolutionary property management system. Amalthea helps property managers and real estate professionals simplify operations, automate procedures, and improve tenant experiences. Discover Amalthea's property listing management, tenant portal, maintenance monitoring, financial management, and reporting tools. Amalthea's user-friendly platform improves productivity, costs, and tenant happiness. Amalthea by Mavinx helps you win the real estate game."
        />
        <meta
          name="description"
          content="Explore Amalthea, our revolutionary property management system. Amalthea helps property managers and real estate professionals simplify operations, automate procedures, and improve tenant experiences. Discover Amalthea's property listing management, tenant portal, maintenance monitoring, financial management, and reporting tools. Amalthea's user-friendly platform improves productivity, costs, and tenant happiness. Amalthea by Mavinx helps you win the real estate game."
        />
        <meta
          name="keywords"
          content="Amalthea, property management solution, real estate industry, property managers, real estate professionals, streamlined operations, process automation, tenant experiences, property listing management, tenant portal, maintenance tracking, financial management, reporting, efficiency, cost reduction, tenant satisfaction, user-friendly platform, competitive real estate market, Mavinx property management solution"
        />
      </Head>
      <Header
        appearance="transparent"
        appearanceLogo="white"
        appearanceNav="white"
        menu={menu}
      />
      <RealEstatePage />
      <Footer />
    </>
  );
}
